import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY || "";

/**
 * Supabase client configured with:
 * - localStorage for session persistence (default)
 * - Automatic token refresh enabled
 * - Auto-detection of session from URL (for OAuth redirects)
 */
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    // Store session in localStorage (default, but explicit for clarity)
    storage: window.localStorage,
    // Automatically detect session from URL after OAuth redirect
    autoRefreshToken: true,
    // Persist session across page reloads
    persistSession: true,
    // Detect session from URL hash or query params
    detectSessionInUrl: true,
  },
});
